export default __webpack_public_path__ + "static/swarmplot-41e4bfb5b7b66784a1bfb204ec76e720.png";